import { render, staticRenderFns } from "./TariffManager.vue?vue&type=template&id=459f369c"
import script from "./TariffManager.vue?vue&type=script&lang=ts"
export * from "./TariffManager.vue?vue&type=script&lang=ts"
import style0 from "./TariffManager.vue?vue&type=style&index=0&id=459f369c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports